import React, { useEffect, useState } from 'react'
import SkeletonTable from '../../../components/table/SkeletonTable'
import { Button, Form, Input, Spin, Switch } from 'antd';
import ModalComponent from '../../../components/modals/ModalComponent';
import LoadableButton from '../../../components/buttons/LoadableButton';
import Add from '../../../assets/Add';
import faqColumn from '../../../columns/settings/faq';
import Edit from '../../../assets/Edit';
import Delete from '../../../assets/Delete';
import ConfirmationModal from '../../../components/modals/ConfirmationModal';
import { AddUpdateFaqApi, ChangeFaqStatusApi, DeleteFaqApi, GetFaqListApi } from '../../../api/request/settings/faq';
import toast from 'react-hot-toast';

const Faq = () => {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [isAddEditFaqModalOpen, setIsAddEditFaqModalOpen] = useState(false);
    const [isAddEditLoadingFaq, setIsAddEditLoadingFaq] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isDeleteLoading, setDeleteLoading] = useState(false);
    const [isEditFaq, setIsEditFaq] = useState(false);
    const [isStatusLoading, setIsStatusLoading] = useState(false);
    const [openStatusModal, setOpenStatusModal] = useState(false);
    const [faqId, setFaqId] = useState('');
    const [faqStatus, setFaqStatus] = useState('');
    const [data, setData] = useState([]);
    const [initialValues, setInitialValues] = useState({ question: '', answer: '' });

    const getFaq = async () => {
        try {
            setIsLoading(true);
            const { data } = await GetFaqListApi();
            if (data?.status) {
                setData(
                    data?.data?.map((item) => ({
                        ...item,
                        status: <Switch onClick={() => handleFaqStatus(item)} checked={item?.status === 'active'} checkedChildren="Active" unCheckedChildren="Inactive" />,
                        action: <div className='flex items-center gap-3'>
                            <button onClick={() => handleEditFaqModal(item)}><Edit /></button>
                            <button onClick={() => { setOpenDeleteModal(true); setFaqId(item?.id) }}><Delete /></button>
                        </div>
                    }))
                );
            }
            setIsLoading(false);
        }
        catch (error) {
            setIsLoading(false);
        }
    }

    const handleEditFaqModal = (values) => {
        setIsEditFaq(true);
        setIsAddEditFaqModalOpen(true);
        setFaqId(values?.id);
        form.setFieldsValue({ question: values?.question, answer: values?.answer });
    }

    const addEditHandler = async (values) => {
        try {
            setIsAddEditLoadingFaq(true);
            const params = isEditFaq ? { ...values, id: faqId } : values;
            const { data } = await AddUpdateFaqApi(params);
            if (data?.status) {
                toast.success(data?.message);
                getFaq();
                setIsAddEditFaqModalOpen(false);
                form.resetFields();
                setIsAddEditLoadingFaq(false);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
            setIsAddEditLoadingFaq(false);
        }
    }

    const handleDeleteFaq = async () => {
        try {
            setDeleteLoading(true);
            const { data } = await DeleteFaqApi({ id: faqId });
            if (data?.status) {
                toast.success(data?.message);
                getFaq();
                setOpenDeleteModal(false);
                setDeleteLoading(false);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
            setDeleteLoading(false);
        }

    }

    const handleFaqStatus = (faq) => {
        setFaqId(faq?.id);
        setFaqStatus(faq?.status === 'active' ? 'inactive' : 'active');
        setOpenStatusModal(true);
    }

    const handleStatusChange = async () => {
        try {
            setIsStatusLoading(true);
            const params = { id: faqId, status: faqStatus };
            const { data } = await ChangeFaqStatusApi(params);
            if (data?.status) {
                toast.success(data?.message);
                getFaq();
                setIsStatusLoading(false);
                setOpenStatusModal(false);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
            setIsStatusLoading(false);
        }
    }


    useEffect(() => {
        getFaq();
    }, []);

    useEffect(() => {
        if (!isAddEditFaqModalOpen) {
            setIsEditFaq(false);
            form.resetFields();
        }
    }, [isAddEditFaqModalOpen]);

    return (
        <>
            <div className='border-2 rounded-xl'>
                <div className='flex justify-between mx-5 gap-5 mt-4'>
                    <p className='font-semibold text-xl'>Faq</p>
                    <Button type='primary' className='uppercase' icon={<Add />} onClick={() => setIsAddEditFaqModalOpen(true)}>Add</Button>
                </div>
                <div className='table-radius-0 text-light my-4'>
                    <SkeletonTable columns={faqColumn} data={data} isLoading={isLoading} />
                </div>
            </div>

            {/* ------ add edit faq modal ------- */}
            <ModalComponent isOpen={isAddEditFaqModalOpen} setIsOpen={setIsAddEditFaqModalOpen} >
                <p className='mb-4 text-lg font-semibold text-center'>{!isEditFaq ? 'Add Faq' : 'Edit Faq'}</p>
                <Form autoComplete='off' form={form} initialValues={initialValues} onFinish={addEditHandler}>
                    <Form.Item name='question' className='mb-0 mt-1' rules={[{ required: true, message: 'Please enter question.', },]}>
                        <Input placeholder='Question' size='large' />
                    </Form.Item>
                    <Form.Item name='answer' className='mb-0 mt-5' rules={[{ required: true, message: 'Please enter answer.', },]}>
                        <Input placeholder='Answer' size='large' />
                    </Form.Item>
                    <div className='flex justify-center mt-5'>
                        <LoadableButton
                            className='bg-primary text-white uppercase text-base font-semibold px-6 py-2 rounded-lg mt-2'
                            type='submit'
                            lable={isEditFaq ? 'Update' : 'Submit'}
                            loadingLable={isEditFaq ? 'Updating Faq...' : 'Adding Faq...'}
                            isLoading={isAddEditLoadingFaq}
                        />
                    </div>
                </Form>
            </ModalComponent>

            {/* ------ Confirmation modal for delete ------- */}
            <ConfirmationModal
                isOpen={openDeleteModal}
                setIsOpen={setOpenDeleteModal}
                message='Are you sure, you want to delete faq?'
                onConfirm={() => handleDeleteFaq()}
                isLoading={isDeleteLoading}
                loadingLabel='Deleting Faq...'
            />

            {/* ------ Confirmation modal for status ------- */}
            <ConfirmationModal
                isOpen={openStatusModal}
                setIsOpen={setOpenStatusModal}
                message='Are you sure, you want to change status?'
                onConfirm={() => handleStatusChange()}
                isLoading={isStatusLoading}
                loadingLabel='Changing status...'
            />
        </>
    )
}

export default Faq